import { render } from "./PetProjectOneRemarkDialog.vue?vue&type=template&id=4758b49a"
import script from "./PetProjectOneRemarkDialog.vue?vue&type=script&lang=js"
export * from "./PetProjectOneRemarkDialog.vue?vue&type=script&lang=js"

import exportComponent from "D:\\yiban\\WebProject\\yimeng-admin\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__